var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "blankslot-list",
    class: _vm.mediaAuto ? 'media-auto' : ''
  }, [_c('div', {
    staticClass: "rl-clearfix blankslot-wrap"
  }, _vm._l(_vm.size, function (index) {
    return _c('div', {
      key: index,
      staticClass: "blankslot"
    }, [_vm._m(0, true), _vm._v(" "), _c('p', {
      staticStyle: {
        "width": "70%"
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "width": "30%"
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "width": "60%"
      }
    })]);
  }), 0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "picwrap"
  }, [_c('span'), _vm._v(" "), _c('div', {
    staticClass: "picp"
  }, [_c('p', {
    staticStyle: {
      "width": "90%"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "50%"
    }
  })])]);
}];
export { render, staticRenderFns };